var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50028 13.9124V13.7079C3.5352 13.0531 3.74185 12.4187 4.09974 11.8677C4.6965 11.1991 5.10675 10.3869 5.28971 9.51192C5.33445 8.84518 5.28971 8.16066 5.33445 7.48503C5.65655 4.24024 8.86857 2 11.9464 2H12.0359C15.1674 2 18.2989 4.24024 18.6389 7.48503C18.7015 8.15177 18.6389 8.84518 18.6926 9.51192C18.8711 10.3884 19.2819 11.2017 19.8825 11.8677C20.256 12.4124 20.4697 13.0495 20.4999 13.7079V13.9124C20.5054 14.7993 20.1876 15.6582 19.6052 16.3304C18.858 17.1274 17.8424 17.624 16.751 17.7261C13.5642 18.135 10.3376 18.135 7.15072 17.7261C6.07207 17.6157 5.07052 17.1197 4.33237 16.3304C3.76823 15.6518 3.4724 14.7921 3.50028 13.9124Z",
    fill: "url(#paint0_linear_791_795)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.1632 19.095C12.528 19.0505 12.009 19.095 11.4901 19.095C10.9755 19.0861 10.4617 19.1398 9.96015 19.255C9.53068 19.3528 9.06543 19.5839 9.06543 20.0728C9.11049 20.5454 9.36667 20.9729 9.76331 21.2374C10.5274 21.8209 11.4902 22.0856 12.4475 21.9753C13.3779 21.9066 14.2284 21.427 14.7648 20.6685C15.0612 20.2841 14.9936 19.7348 14.6127 19.4328V19.4328V19.4328C14.1616 19.2123 13.6659 19.0967 13.1632 19.095Z",
    fill: "#F5D016"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_791_795",
    x1: 11.9992,
    y1: 2,
    x2: 11.9992,
    y2: 18.0328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActive);
export default __webpack_public_path__ + "static/media/icon_notification_active.c7bd39a7adf8c9872bf398ce6417b437.svg";
export { ForwardRef as ReactComponent };